<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="120"
      ref="FormComponent"
      @handleReset="handleReset"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem :label="$t('WHAT_Assessment_PPT')"
          ><!-- WHAT评分 -->
          <Select v-model="formItem.whatScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot2">
        <FormItem :label="$t('HOW_Assessment_PPT')"
          ><!-- HOW评分 -->
          <Select v-model="formItem.howScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot3">
        <FormItem :label="$t('Overall_Assessment_PPT')"
          ><!-- Overall评分 -->
          <Select v-model="formItem.wholeScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <!-- 潜能评分 -->
      <!-- <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot4">
        <FormItem :label="$t('Potential_Rating') + $t('potentialOld')"
          >
          <Select v-model="formItem.potentialScore" clearable>
            <Option
              v-for="item in PotentialScore"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col> -->
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot9">
        <FormItem :label="$t('User_Potential')"
          ><!-- 潜能评分 -->
          <Select v-model="formItem.newPotentialScore" clearable>
            <Option
              v-for="item in NewPotentialScore"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot5"
        v-if="tabName == 'PerformanceEvaluation'"
      >
        <FormItem :label="$t('isSubmit')"
          ><!-- 是否已提交 -->
          <Select v-model="formItem.isSubmit" clearable>
            <Option
              v-for="item in YesOrNoList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6"  slot="slot11" >
        <FormItem :label="$t('movment')"
          ><!-- 绩效趋势 -->
          <Select v-model="formItem.movment" clearable>
            <Option
              v-for="item in movmentList"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6"  slot="slot12">
        <FormItem :label="$t('TalentCategory')"
          ><!-- 人才类别 -->
          <Select v-model="formItem.talentCategoryName" clearable>
            <Option
              v-for="item in talentCategoryList"
              :value="item.ch_value"
              :key="item.ch_value"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot13"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
    </FormComponent>
  <Table
      border
      :loading="loading"
      :columns="colHidden"
      :data="data"
      style="margin: 20px 0"
      @on-select-cancel="TableSelectCancelRow"
      @on-select-all-cancel="cancelAll"
      @on-select-all="selsetAll"
      @on-select="peoOnSelectRow"
      ref="selection"
    >
      <template
        slot-scope="{ row, index }"
        slot="whatScore"
        style="width: 100%"
      >
        <Select
          v-model="row.whatScore"
          @on-change="targetItemChange(row, index, 'whatScore')"
          transfer
          :disabled="row.selsetDisabled"
        >
          <Option v-for="item in Score" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="howScore" style="width: 100%">
        <Select
          v-model="row.howScore"
          @on-change="targetItemChange(row, index, 'howScore')"
          transfer
          :disabled="row.selsetDisabled"
        >
          <Option v-for="item in Score" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="wholeScore"
        style="width: 100%"
      >
        <Select
          v-model="row.wholeScore"
          @on-change="targetItemChange(row, index, 'wholeScore')"
          transfer
          disabled
        >
          <Option v-for="item in Score" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="potentialScore"
        style="width: 100%"
      >
        <Select
          v-model="row.potentialScore"
          @on-change="targetItemChange(row, index, 'potentialScore')"
          transfer
          :disabled="row.selsetDisabled"
        >
          <Option
            v-for="item in PotentialScore"
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="movment"
        style="width: 100%;"
      >
      <div style="display:flex;align-items: center;">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          style="margin-right:10px"
          @click="onEditItem(row, index, 'overall')"
        >
          {{ $t("movment") }}
        </Button>
        <div>{{row[lang == "zh" ? "movment" : "movmentEName"]}}</div>
      </div>

      </template>
      <template
        slot-scope="{ row, index }"
        slot="newPotentialScore"
        style="width: 100%;"
      >
      <div style="display:flex;align-items: center;">

        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          style="margin-right:10px"
          @click="onEditItem(row, index, 'qn')"
        >
          {{ $t("User_Potential") }}
        </Button>
        <Select
          v-model="row.newPotentialScore"
          @on-change="targetItemChange(row, index, 'newPotentialScore')"
          transfer
          :disabled="true"
        >
          <Option
            v-for="item in NewPotentialScore"
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </div>

      </template>
      <template slot-scope="{ row, index }" slot="comment" style="width: 100%">
        <Input
          type="textarea"
          v-model="row.comment"
          :autosize="true"
          :disabled="row.selsetDisabled"
          @on-change="targetItemChange(row, index, 'comment')"
        />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          :disabled="row.achApplyId == 'NotFindApplyId'"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
      <template slot-scope="{ row, index }" slot="action1">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="openApplyPop(row, index)"
        ></Button>
      </template>
      <template slot-scope="{ row, index }" slot="action2">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="onEditItem(row, index, 'overall')"
        >
          {{ $t("movment") }}
        </Button>
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="onEditItem(row, index, 'qn')"
        >
          {{ $t("User_Potential") }}
        </Button>
      </template>
    </Table>
    <Table
      :columns="colHiddenA"
      :data="exportTableData"
      ref="TableRef"
      id="Table"
      v-show="false"
    ></Table>
    <div
      style="
        margin: 20px 0;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        align-items: flex-end;
      "
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        @on-change="pageChange"
        :page-size-opts="[10, 50, 100, 150]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <div>
        <Button
          type="primary"
          style="margin-top: 15px"
          @click="cancelSubmitMonthed1"
          :disabled="loading"
          v-if="tabName == 'PerformanceEvaluation'"
          ><!-- 取消提交 -->{{ $t("CancelSubmit") }}</Button
        >
        <Button
          type="primary"
          style="margin-top: 15px"
          v-if="isChinaOD == '1' || isBuOd == '1'"
          :disabled="loading"
          @click="pushClick"
          ><!-- 推送 -->{{ $t("Push") }}</Button
        >
        <Button
          type="primary"
          style="margin-top: 15px"
          @click="submitTable"
          :disabled="loading"
          v-if="tabName == 'PerformanceEvaluation'"
          ><!-- 提交 -->{{ $t("Submit") }}</Button
        >
        <Button
          type="primary"
          style="margin-top: 15px"
          @click="exportData"
          :disabled="loading"
          ><!-- 导出 -->{{ $t("PB_Export") }}</Button
        >
        <Button
          type="primary"
          style="margin-top: 15px"
          @click="returnPage"
          :disabled="loading"
          v-if="showreturnbtn"
          ><!-- 返回 -->{{ $t("Return") }}</Button
        >
      </div>
    </div>

    <ApprovalRemark ref="ApprovalRemark" @ok="okSave"></ApprovalRemark>
    <PerformanceEvaluationModal
      ref="PerformanceEvaluationModal"
    ></PerformanceEvaluationModal>
    <Modal
      v-model="checkScoreModel"
      :title="$t('Emp_Ach_mess27')"
      :loading="loading"
      @on-ok="saveTableData"
    >
      <p v-for="(item, index) in checkScoreList" :key="index">
        {{ lang == "zh" ? item.userName : item.userEName }}（{{
          item.empCode
        }}）{{ $t("Emp_Ach_mess13") }}
      </p>
    </Modal>
    <Modal
      v-model="checkAllScoreModel"
      :title="$t('Emp_Ach_mess27')"
      :loading="loading"
      @on-ok="saveAllTableData"
    >
      <p v-for="(item, index) in checkScoreList" :key="index">
        {{ lang == "zh" ? item.userName : item.userEName }}（{{
          item.empCode
        }}）{{ $t("Emp_Ach_mess13") }}
        <!-- 的评分不符合规则，确认是否提交？ -->
      </p>
    </Modal>
    <Modal
      width="800px"
      v-model="checkApplyNotApproval"
      title="有员工目标设定确认未通过,不允许提交初评数据。"
    >
      <Table
        border
        :loading="loading"
        :columns="SubmitCheckColumns"
        :data="checkApplyNotApprovalList"
        ref="Table2"
        style="margin: 20px 0"
        :height="checkApplyNotApprovalList.length > 10 ? '500' : ''"
      ></Table>
      <div style="margin: 20px 0; display: flex; justify-content: flex-end">
        <div style="margin-left: 15px">
          <Button type="primary" @click="exportData2" :disabled="loading"
            ><!-- 全部确认 -->导出</Button
          >
        </div>
      </div>
    </Modal>
    <Modal
      width="800px"
      v-model="checkBeSubmit"
      title="以下员工已提交过初评分数，请确认数据"
    >
      <Table
        border
        :loading="loading"
        :columns="BeCheckSubmitList"
        :data="checkBeSubmitList"
        ref="Table3"
        style="margin: 20px 0"
        :height="checkBeSubmitList.length > 10 ? '500' : ''"
      ></Table>
      <div slot="footer">
        <Button @click="searchTableData"
          ><!-- 保存 -->{{ $t("Confirm") }}</Button
        >
      </div>
    </Modal>
    <Modal
      width="800px"
      v-model="cancelSubmit"
      title="以下员工已被会议激活,无法取消提交"
    >
      <Table
        border
        :loading="loading"
        :columns="cancelSubmitList"
        :data="cancelSubmitList1"
        ref="Table4"
        style="margin: 20px 0"
        :height="checkBeSubmitList.length > 10 ? '500' : ''"
      ></Table>
      <div slot="footer">
        <Button @click="cancelSave"><!-- 保存 -->{{ $t("Confirm") }}</Button>
      </div>
    </Modal>
    <Modal v-model="batchModalShow" :title="$t('批量设置评分')" width="600"
      ><!-- 批量设置评分 -->
      <Form label-position="left" :label-width="150">
        <Row>
          <FormItem :label="$t('潜能评分')">
            <Select
              v-model="bathNewPotentialScore"
              clearable
              transfer
              style="width: 200px"
              :disabled="true"
            >
              <Option
                v-for="item in NewPotentialScore"
                :value="item.code"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </FormItem>
          <Button
            type="primary"
            icon="md-reorder"
            @click="onEditItem({}, -1, 'qn')"
          >
            {{ $t("Potential") }}
          </Button>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" @click="batchScoringConfirm"
          ><!-- 保存 -->{{ $t("Save") }}</Button
        >
        <Button type="text" @click="batchModalShow = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </Modal>

    <PotentialRange ref="PotentialRangeRef" @onSetScore="onSetScore" />
  </div>
</template>

<script>
import FormComponent from "../FormComponent.vue";
import axios from "axios";
import "../../js/westeros.js";
import DateUtil from "@/util/DateUtil";
import ApprovalRemark from "../modalComponents/ApprovalRemark.vue";
import PerformanceEvaluationModal from "../modalComponents/PerformanceEvaluationModal.vue";
import PotentialRange from "../PotentialRange.vue";

export default {
  components: {
    FormComponent,
    ApprovalRemark,
    PerformanceEvaluationModal,
    PotentialRange,
  },
  data() {
    return {
      date: new DateUtil(),
      showreturnbtn: false,
      prevent: false,
      formItem: {},
      searchItem: {year:""},
      selectList: [],
      YesOrNoList: [],
      loading: false,
      total: 0,
      total2: 0,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 50,
      },
      submitPageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 50,
      },
      data: [],
      dataTable: [],
      dataChart: [
        { peopleNum: 0 },
        { peopleNum: 0 },
        { peopleNum: 0 },
        { peopleNum: 0 },
        { peopleNum: 0 },
      ],
      spinShow: false,
      radioValue: "1",
      id: "",
      Score: [],
      tabName: "PerformanceEvaluation",
      exportTableData: [],
      PotentialScore: [],
      NewPotentialScore: [],
      PeoPleBoardStatus: [],
      isChinaOD: "",
      isBuOd: "",
      returnState: false,
      beEnd: "0",
      tabShow: false,
      allData: [],
      radioIndex: "1",
      ManagementLevel: [],
      Band: [],
      BeQuit: [],
      checkScoreModel: false,
      checkScoreList: [],
      checkAllScoreModel: false,
      checkApplyNotApproval: false,
      checkApplyNotApprovalList: [],
      checkBeSubmit: false,
      checkBeSubmitList: [],
      cancelSubmit: false,
      cancelSubmitList1: [],
      overallScoreList: [],
      cancelSubmitModal: false,
      editIndex: "",
      bathNewPotentialScore: "",
      batchModalShow: false,
      bathFormItem: {},
      movmentList:[
      {
          code:"3",
          ch_value:"高",
          en_value:"High"
        },
        {
          code:"2",
          ch_value:"中",
          en_value:"Low"
        },
        {
          code:"1",
          ch_value:"低",
          en_value:"Middle"
          
        },
      ],
      talentCategoryList:[
      {
          code:"1",
          ch_value:"聚焦绩效",
          en_value:"Performance Focus"
          
        },
        {
          code:"2",
          ch_value:"稳定贡献",
          en_value:"Core Talent"
        },
        {
          code:"3",
          ch_value:"后备力量",
          en_value:"Pipeline"
        },
        {
          code:"4",
          ch_value:"核心人才",
          en_value:"Strategic Few"
        },
      ]
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    SubmitCheckColumns() {
      return [
        {
          title: "员工工号",
          key: "empCode",
          align: "center",
          minWidth: 130,
          fixed: "left",
        },
        {
          title: "员工姓名",
          key: this.lang == "zh" ? "userName" : "userEName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: "确认人姓名",
          key: this.lang == "zh" ? "approvalCName" : "approvalEName",
          align: "center",
          minWidth: 130,
          fixed: "left",
        },
        {
          title: "确认人工号",
          key: "approvalCode",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
      ];
    },
    columns() {
      return [
        {
          type: "selection",
          minWidth: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: this.$t("PB_Performance__Sheet") /* 绩效表单 */,
          key: "action",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "left",
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "position",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: this.lang == "zh" ? "dirSupName" : "dirSupEName",
          align: "center",
          minWidth: 120,
          // sortable: true
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 120,
        },
        // {
        //   title: this.$t("WHAT_Assessment_PPT") /* WHAT评分 */,
        //   key: "whatScore",
        //   slot: "whatScore",
        //   align: "center",
        //   minWidth: 160,
        // },
        // {
        //   title: this.$t("HOW_Assessment_PPT") /* HOW评分 */,
        //   key: "howScore",
        //   slot: "howScore",
        //   align: "center",
        //   minWidth: 160,
        // },
        // {
        //   title: this.$t("Overall_Assessment_PPT") /* Overall评分 */,
        //   key: "wholeScore",
        //   slot: "wholeScore",
        //   align: "center",
        //   minWidth: 160,
        // },
        // {
        //   title: this.$t("Potential_Rating") /* 潜能评分 */,
        //   key: "potentialScore",
        //   slot: "potentialScore",
        //   align: "center",
        //   minWidth: 160,
        // },
        {
          title: this.$t("movment") /* 绩效趋势 */,
          key: this.lang == "zh" ? "movment" : "movmentEName",
          align: "center",
          slot: "movment",
          width: 195,
        },
        {
          title: this.$t("User_Potential") /* 潜能评分 */,
          key: "newPotentialScore",
          slot: "newPotentialScore",
          align: "center",
          minWidth: 230,
        },
        {
          title: this.$t("TalentCategory") /* 人才类别 */,
          key: this.lang == "zh" ? "talentCategoryName" : "talentCategoryEName",
          align: "center",
          width: 100,
        },
        // {
        //   title: this.$t("Action"),
        //   slot: "action2",
        //   align: "center",
        //   width: 210,
        // },
      ];
    },
    columnsA() {
      return [
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "position",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: this.lang == "zh" ? "dirSupName" : "dirSupEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 120,
        },
        // {
        //   title: this.$t("WHAT_Assessment_PPT") /* WHAT评分 */,
        //   key: "whatScore",
        //   align: "center",
        //   minWidth: 160,
        // },
        // {
        //   title: this.$t("HOW_Assessment_PPT") /* HOW评分 */,
        //   key: "howScore",
        //   align: "center",
        //   minWidth: 160,
        // },
        // {
        //   title: this.$t("Overall_Assessment_PPT") /* Overall评分 */,
        //   key: "wholeScore",
        //   align: "center",
        //   minWidth: 160,
        // },
        // {
        //   title: this.$t("Potential_Rating") /* 潜能评分 */,
        //   key: "potentialScore",
        //   align: "center",
        //   minWidth: 160,
        // },
        {
          title: this.$t("movment") /* 绩效趋势 */,
          key: this.lang == "zh" ? "movment" : "movmentEName",
          align: "center",
          width: 95,
        },
        {
          title: this.$t("User_Potential") /* 潜能评分 */,
          key: "newPotentialScore",
          align: "center",
          minWidth: 160,
        },
        {
          title: this.$t("TalentCategory") /* 人才类别 */,
          key: this.lang == "zh" ? "talentCategoryName" : "talentCategoryEName",
          align: "center",
          width: 100,
        },
      ];
    },
    columnsChart() {
      return [
        {
          title: this.$t("Items") /* 评分项目 */,
          key: this.lang == "zh" ? "scopeType" : "enScopeType",
          align: "center",
          minWidth: 120,
          className: "demo-table-info-column",
        },
        {
          title: this.$t("PB_1-Requires_Improvement") /* 1-需要改善 */,
          key: "achNormal1",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("PB_2-Typically_Meets") /* 2-部分达标 */,
          key: "achNormal2",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("PB_3-Achieved") /* 3-达到要求 */,
          key: "achNormal3",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("PB_4-Exceeds") /* 4-超越要求 */,
          key: "achNormal4",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("PB_5-Exceptional") /* 5-优秀出色 */,
          key: "achNormal5",
          align: "center",
          minWidth: 120,
        },
      ];
    },
    BeCheckSubmitList() {
      return [
        {
          title: "员工工号",
          key: "empCode",
          align: "center",
          minWidth: 130,
          fixed: "left",
        },
        {
          title: "员工姓名",
          key: this.lang == "zh" ? "userName" : "userEName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
      ];
    },
    cancelSubmitList() {
      return [
        {
          title: "员工工号",
          key: "empCode",
          align: "center",
          minWidth: 130,
          fixed: "left",
        },
        {
          title: "员工姓名",
          key: this.lang == "zh" ? "userName" : "userEName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
      ];
    },
    colHidden: function () {
      //重点
      return this.columns.filter(function (e) {
        return !e.hidden;
      });
    },
    colHiddenA: function () {
      //重点
      return this.columnsA.filter(function (e) {
        return !e.hidden;
      });
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
  },
  mounted() {
    this.searchNewPotentialYear()
    this.getListData();
  },
 
  methods: {
    searchNewPotentialYear() {
      this.axios.post('/achReport/searchNewPotentialYear',{}).then(res => {
        this.$nextTick(() => {
          this.$refs.FormComponent.formItem.year = res + '';
          this.searchItem.year = res + '';
          this.getData();
        });
      })
    },
    onSetScore(e) {
      // 批量
      if (this.editIndex == -1) {
        this.bathNewPotentialScore = e.score;
        this.bathFormItem.newPotentialScore = this.bathNewPotentialScore;
        this.bathFormItem.newPotentialScoreList = e.potentialList || [];
      } else {
        this.$set(this.data[this.editIndex], "newPotentialScore", e.score);
        this.selectList = [];
        this.getData(JSON.stringify(this.searchItem));
      }
    },
    onEditItem(row, index, type) {
      this.editIndex = index;
      this.$refs.PotentialRangeRef.onEditItem(row, type);
    },
    cancelSave() {
      this.cancelSubmit = false;
      this.getData();
    },
    searchTableData() {
      this.checkBeSubmit = false;
      this.getData();
    },

    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.Score = res.Score;
          this.PotentialScore = res.PotentialScore;
          this.NewPotentialScore = res.NewPotentialScore;
          this.$refs.FormComponent.functionList = res.functionList;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.PeoPleBoardStatus = res.PeoPleBoardStatus;
          this.ManagementLevel = res.ManagementLevel;
          this.Band = res.Band;
          this.BeQuit = res.BeQuit;
          this.YesOrNoList = res.YesOrNo;
          this.overallScoreList = res.overallScoreList;
        }
      });
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      let obj = {
        id: this.id,
        ...this.pageInfo,
        ...this.searchItem,
      };
      let url = "";
      this.loading = true;
      if (this.tabName == "PerformanceEvaluation") {
        url = "/achReport/selectPotentialReportAssess";
      }
      this.dataTable = [];
      axios.post(url, obj).then((res) => {
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
        if (res) {
          let that = this;
          this.data = res.achPeopleBoardList;
          this.allData = res.allData;
          
          this.data.forEach((el, index) => {
            el._disabled = false;
            el.selsetDisabled = false;
            // 如果当前登录人是 China OD 或者是 BU OD的话
            if (res.isChinaOD == 1) {
              if (el.disabledFlag != 0 && el.statusCode != 6) {
                el._disabled = true;
              }
            } else if (res.isBuOd == 1) {
              if (
                el.disabledFlag != 0 &&
                (el.statusCode != 20 || el.attribute1 != "BU")
              ) {
                el._disabled = true;
              }
            } else {
              if (el.disabledFlag == "1") {
                el._disabled = true;
              }
            }
          });
          this.$nextTick(() => {
            this.selectList.forEach((res) => {
              this.data.forEach((el, index) => {
                el._checked = false;
                if (el.id === res.id) {
                  this.$refs.selection.objData[index]._isChecked = true;
                }
              });
            });
          });
          this.total = parseInt(res.pageInfo.total);
          if (res.normalTableList) {
            this.dataTable = res.normalTableList;
          }

          this.isChinaOD = res.isChinaOD;
          this.isBuOd = res.isBuOd;
        }
      });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },

    cancelSubmitMonthed1() {
      if (this.selectList.length > 0) {
        this.$Modal.confirm({
          title: this.$t("pleaseSureCancelEmp"),
          onOk: () => {
            this.cancelSubmitMonthed();
          },
        });
      } else {
        this.$Message.error(this.$t('pleaseSelectNeedCancelEmp'));//"请选择需要取消提交的员工"
      }
    },
    cancelSubmitMonthed() {
      //todo
      this.loading = true;
      axios
        .post("/achReport/cancelSubmitScore", this.selectList)
        .then((res) => {
          this.loading = false;
          if (res) {
            if (res.result == 23) {
              console.log("res", res);
              this.cancelSubmitList1 = res.data;
              this.cancelSubmit = true;
            } else {
              console.log("res", res);
              this.selectList = [];
              this.$Message.success(this.$t("取消成功"));
              this.getData(JSON.stringify(this.searchItem));
            }
          }
        });
    },
    async targetItemChange(row, index, key) {
      if (this.selectList.length > 0) {
        this.selectList.forEach((res, i) => {
          if (res.id == row.id) {
            this.$set(this.selectList[i], key, row[`${key}`]);
            this.$set(
              this.selectList[index],
              "wholeScore",
              this.getOverallScore(row.whatScore, row.howScore)
            );
          }
        });
        key && this.$set(this.data[index], key, row[`${key}`]);
      } else {
        key && this.$set(this.data[index], key, row[`${key}`]);
      }
      console.log(this.data[index], "赋值前");
      if (row.whatScore && row.howScore) {
        this.$set(
          this.data[index],
          "wholeScore",
          this.getOverallScore(row.whatScore, row.howScore)
        );
        console.log(this.data[index], "赋值中");
      }
      console.log(this.data[index], "复制后");
      this.$nextTick(() => {
        this.selectList.forEach((res) => {
          this.data.forEach((el, index) => {
            el._checked = false;
            if (el.id === res.id && el._disabled != true) {
              this.$refs.selection.objData[index]._isChecked = true;
            }
          });
        });
      });
    },
    getOverallScore(whatScore, howScore) {
      let overallScore = "";
      this.overallScoreList.forEach((res) => {
        if (whatScore == res.whatScore && howScore == res.howScore) {
          overallScore = res.overallScore;
        }
      });
      return overallScore;
    },
    checkScore(item) {
      return true;
    },
    saveTableData() {
      if (this.saveStatus && this.tabName == "PerformanceEvaluation") {
        this.loading = true;
        axios.post("/achReport/saveReportAchAssess", this.data).then((res) => {
          this.loading = false;
          if (res) {
            if (res.result == 22) {
              this.selectList = [];
              this.checkBeSubmitList = res.data;
              this.checkBeSubmit = true;
            } else {
              this.$Message.success(this.$t("Save_Successful"));
              this.getData(JSON.stringify(this.searchItem));
            }
          }
        });
      } else if (!this.saveStatus && this.tabName == "PerformanceEvaluation") {
        this.loading = true;
        axios
          .post("/achReport/submitReportAchAssess", this.selectList)
          .then((res) => {
            this.loading = false;
            if (res) {
              if (res.result == 21) {
                console.log("res", res);
                this.checkApplyNotApprovalList = res.data;
                this.checkApplyNotApproval = true;
              } else if (res.result == 22) {
                this.selectList = [];
                this.checkBeSubmitList = res.data;
                this.checkBeSubmit = true;
              } else {
                console.log("res", res);
                this.selectList = [];
                this.$Message.success(this.$t("sbumit_Success"));
                this.getData(JSON.stringify(this.searchItem));
              }
            }
          });
      }
    },
    saveTable() {
      if (this.tabName == "PerformanceEvaluation") {
        this.saveStatus = true;
        this.checkScoreList = [];
        this.data.forEach((item) => {
          if (!this.checkScore(item)) {
            this.checkScoreList.push(item);
          }
        });
        if (this.checkScoreList.length > 0) {
          this.checkScoreModel = true;
        } else {
          this.saveTableData();
        }
      }
    },
    submitTable() {
      this.saveStatus = false;
      if (this.selectList.length > 0) {
        this.$Modal.confirm({
          title: this.$t("longText53"),
          onOk: () => {
            this.checkScoreList = [];
            this.selectList.forEach((item) => {
              if (!this.checkScore(item)) {
                this.checkScoreList.push(item);
              }
            });
            if (this.checkScoreList.length > 0) {
              this.checkScoreModel = true;
            } else {
              this.saveTableData();
            }
          },
        });
      } else {
        this.$Message.error(this.$t("Emp_Ach_mess6"));
      }
    },
    saveNew() {
      this.saveStatus = true;
      if (this.selectList.length > 0) {
        this.saveStatus = true;
        this.checkScoreList = [];
        this.selectList.forEach((item) => {
          if (!this.checkScore(item)) {
            this.checkScoreList.push(item);
          }
        });
        if (this.checkScoreList.length > 0) {
          this.checkScoreModel = true;
        } else {
          this.saveTableData();
        }
      } else {
        this.$Message.error(this.$t("Emp_Ach_mess7")); //"请选择需要保存的员工。"
      }
    },
    okSave(val) {
      this.selectList.forEach((el) => {
        (el.decision = this.returnState ? "2" : "1"), (el.idea = val);
      });
      this.loading = true;
      axios
        .post("/AchPeopleBoard/submitPeopleBoardScore", this.selectList)
        .then((res) => {
          if (res) {
            this.selectList = [];
            this.$Message.success(this.$t("sbumit_Success"));
            this.getData(JSON.stringify(this.searchItem));
          } else {
            this.loading = false;
          }
        });
    },
    itemClick(list) {
      this.selectList = JSON.parse(JSON.stringify(list));
    },
    pushClick() {
      if (this.selectList.length > 0) {
        this.$Modal.confirm({
          title: this.$t("Emp_Ach_mess26"), //确认推送
          onOk: () => {
            axios
              .post("/AchPeopleBoard/chinaODSubmit", this.selectList)
              .then((res) => {
                if (res) {
                  this.$Message.success(this.$t("Emp_Ach_mess8")); //推送成功
                  this.getData(JSON.stringify(this.searchItem));
                  this.$nextTick(() => {
                    this.selectList = [];
                  });
                }
              });
          },
        });
      } else {
        this.$Message.error(this.$t("Select_Employee"));
      }
    },
    paceTable() {
      axios
        .post("/AchPeopleBoard/synchronizationEvaResult", {
          id: this.id,
          year: this.searchItem.year || this.date.dateVal(new Date(), "YYYY"),
        })
        .then((res) => {
          if (res) {
            this.getData(JSON.stringify(this.searchItem));
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      //TODO
      this.saveStatus = true;
      // this.saveTableData();
      this.getData(JSON.stringify(this.searchItem));
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex === 1) {
        return [1, 2];
      } else if (rowIndex === 0 && columnIndex === 2) {
        return [0, 0];
      }
      if (rowIndex === 0 && columnIndex === 4) {
        return [1, 5];
      } else if (rowIndex === 0 && columnIndex === 5) {
        return [0, 0];
      }
      if (rowIndex === 2 && columnIndex === 0) {
        return {
          rowspan: 2,
          colspan: 1,
        };
      } else if (rowIndex === 3 && columnIndex === 0) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
      if (rowIndex === 3 && columnIndex === 1) {
        return [1, 2];
      } else if (rowIndex === 3 && columnIndex === 2) {
        return [0, 0];
      }
      if (rowIndex === 3 && columnIndex === 4) {
        return [1, 2];
      } else if (rowIndex === 3 && columnIndex === 5) {
        return [0, 0];
      }
    },
    returnPage() {
      this.$router.back();
    },
    exportData2() {
      this.$nextTick(() => {
        this.$exportExcel(
          "Table2",
          "目标设定确认未通过人员名单" +
            this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm")
        );
      });
    },
    exportData() {
      let obj = {
        id: this.id,
        pageNo: 1,
        pageSize: 10000,
        ...this.searchItem,
      };
     this.loading = true;
       axios({
        url: "/achReport/exportNewPotentialData",
        method: "post",
        data: obj,
        responseType: "blob"
      })
        .then(res => {
          var A = this.$store.getters.pageData.axiosHeader[
            "content-disposition"
          ].split("filename=")[1];
          var FileSaver = require("file-saver");
          FileSaver.saveAs(new Blob([res]), decodeURIComponent(A));
          this.loading = false;
        })
    },
    returnSave() {
      if (this.selectList.length > 0) {
        let returnStatus = this.selectList.filter(
          (res) => res.statusCode == "7"
        );
        if (returnStatus.length > 0) {
          return this.$Message.error(this.$t("Emp_Ach_mess10")); //已经退回的申请，请重新确认
        }
        this.$Modal.confirm({
          title: this.$t("Emp_Ach_mess11"), //确认退回
          onOk: () => {
            this.selectList.forEach((el) => {
              el.decision = "2";
              el.idea = "";
            });
            this.loading = true;
            axios
              .post("/AchPeopleBoard/submitPeopleBoardScore", this.selectList)
              .then((res) => {
                if (res) {
                  this.selectList = [];
                  this.$Message.success(this.$t("Emp_Ach_mess12"));
                  this.getData(JSON.stringify(this.searchItem));
                } else {
                  this.loading = false;
                }
              });
            this.returnState = true;
          },
        });
      } else {
        this.$Message.error(this.$t("Select_Employee"));
      }
    },
    checkBtn(row, index) {
      const href =
        "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
        row.achApplyId +
        "&serialnumber=" +
        row.serialnumber +
        "&achStage=" +
        row.achStage +
        "&year=" +
        row.year +
        "&userName=" +
        row.userName +
        "&returnFlag='1'";
      window.open(href, "_blank");
    },
    TableSelectCancelRow(selection, row) {
      this.selectList.forEach((el, index) => {
        if (el.id == row.id) {
          this.selectList.splice(index, 1);
        }
      });
    },
    peoOnSelectRow(selection, row) {
      if (!this.selectList.includes(row.id)) {
        this.selectList.push(row);
      }
    },
    selsetAll(selection) {
      this.data.forEach((el) => {
        if (!el._disabled) {
          this.selectList.push(el);
        }
      });
      let map = new Map();
      for (let item of this.selectList) {
        map.set(item.id, item);
      }
      this.selectList = [...map.values()];
    },
    cancelAll(selection) {
      this.data.forEach((row) => {
        this.selectList.forEach((el, index) => {
          if (el.id == row.id) {
            this.selectList.splice(index, 1);
          }
        });
      });
    },
    handleReset() {
      this.formItem = {};
      this.searchItem.year = this.date.dateVal(new Date(), "YYYY");
    },
    openApplyPop(row, index) {
      this.$refs.PerformanceEvaluationModal.modalShow = true;
      this.$refs.PerformanceEvaluationModal.formItem = row;
      this.$refs.PerformanceEvaluationModal.getData();
    },
    allConfirm() {
      this.$Modal.confirm({
        title: this.$t("Emp_Ach_mess23"), //是否全部确认
        onOk: () => {
          this.loading = true;
          axios
            .post("/AchPeopleBoard/checkConfirmPBApprovalList", {})
            .then((res) => {
              this.loading = false;
              if (res) {
                if (res.flag == "1") {
                  this.checkScoreList = res.achPeopleBoardList;
                  this.checkAllScoreModel = true;
                } else {
                  this.saveAllTableData();
                }
              }
            });
        },
      });
    },
    saveAllTableData() {
      this.loading = true;
      axios.post("/AchPeopleBoard/ConfirmPBApprovalList", {}).then((res) => {
        this.loading = false;
        if (res) {
          this.$Message.success(this.$t("Approval_Completed"));
          this.getData(JSON.stringify(this.searchItem));
        }
      });
    },
    batchScoreSave() {
      if (this.selectList.length > 0) {
        this.batchModalShow = true;
        this.bathNewPotentialScore = "";
        this.bathFormItem.year = this.searchItem.year;
        this.bathFormItem.dataList = this.selectList;
      } else {
        this.$Message.error(this.$t("PleaseSelectNeedScopeEmp")); //"请选择需要评分的员工"
      }
    },
    batchScoringConfirm() {
      this.$Modal.confirm({
        title: "是否确认？",
        onOk: () => {
          this.spinShow = true;
          axios
            .post("/achReport/saveEmpAchScoreList", this.bathFormItem)
            .then((res) => {
              this.spinShow = false;
              this.batchModalShow = false;
              if (res) {
                this.getData(JSON.stringify(this.searchItem));
                this.batchScoringConfirm2();
              }
            });
        },
      });
    },
    batchScoringConfirm2() {
      this.selectList = [];
    },
    batchScoringConfirm3(res) {
      (this.selectList = []), (this.checkBeSubmit = true);
      this.checkBeSubmitList = res.data;
    },
  },
};
</script>

<style lang="less" scoped>


</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/AchReportHRComponents/potential.vue